module.exports = __webpack_public_path__ + "media/images/photo/plans/places/keage-b9d648a224bcce7e3debd60deebf1462.png";